import { Container, Typography } from '@cleartrip/ct-design-components'

interface EmiBankRecoHeadingProps {
    shouldShowRecommended: boolean
    text: string
}

const EmiBankRecoHeading = ({ shouldShowRecommended, text }: EmiBankRecoHeadingProps) => {
    return shouldShowRecommended ? (
        <Container className="p-4" backgroundColor="#F3F3F3" style={{ borderTop: '1px solid #E0E0E0' }}>
            <Typography variant={'HM3'} color="subheading">
                {text}
            </Typography>
        </Container>
    ) : (
        <></>
    )
}

export default EmiBankRecoHeading
